export const FEATURES = {
  APPLE_SIGN_IN: 'appleSignIn',
  GOOGLE_LOGIN: 'googleLogin',
  MODULE_CUSTO: 'moduleCusto',
  POPIN_AGE_GATE: 'popinAgeGate',
  PRIMEUR_CAMPAIGN: 'primeurCampaign',
  ADD_SUFFIX_META: 'addSuffixMeta',
  MODULE_WISHLIST: 'moduleWishList',
  MODULE_BLOG: 'moduleBlog',
  MODULE_MY_CELLAR: 'moduleMyCellar',
  MODULE_CUSTOMER_LOYALTY: 'moduleLoyaltyProgram',
  MODULE_ADD_CARDS: 'moduleAddCards',
  MODULE_EXPRO: 'moduleExpro',
  COMMENT_IN_ORDER: 'commentInOrder',
  APPLE_QUICK_PAY: 'appleQuickPay'
};
